import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Card, CardBody, Col, Row, Container } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Btn, Breadcrumbs, P, H5 } from "../../../AbstractElements";
import { FilePlus } from "react-feather";

//DataTable
import { CandidatesTableColumn } from "../../../Data/DataTables/Candidates";

//Types
import { ViewCandidates } from "../../../Types/Applicants/Candidates";

//Services
import {
  VIEW_CANDIDATES_QUERY_KEY,
  applicantsService,
} from "../../../Services/applicantsService";

const CandidateTable = () => {
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");

  const QueryKey = [...VIEW_CANDIDATES_QUERY_KEY];

  const { data: candidatesData = [], isLoading: CandidatesisLoading } =
    useQuery<ViewCandidates[]>({
      queryKey: QueryKey,
      queryFn: () => applicantsService.getAllByStatus("1,2,3,4,5,6,7"),
    });

  const filteredItems: ViewCandidates[] = candidatesData.filter((item) =>
    Object.values(item).some(
      (value) =>
        value &&
        value.toString().toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  return (
    <Card className="shadow-sm">
      <CardBody>
        <H5 className="mb-0">Candidate Management</H5>

        <P className="mb-3 f-light f-w-200 f-12">
          This module displays all submitted applicants for review and
          interview. Recruiters can evaluate candidates and take actions such as
          scheduling interviews, hiring, or rejecting applications.
        </P>

        <Btn
          color="primary"
          onClick={() =>
            window.open(`${process.env.PUBLIC_URL}/apply-now`, "_blank")
          }
          style={{
            display: "flex",
            alignItems: "center",
            gap: "2px",
          }}
        >
          <FilePlus size={16} />
          Application Form
        </Btn>

        <FilterComponent
          onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
            setFilterText(e.target.value)
          }
          filterText={filterText}
        />

        <div className="table-responsive theme-scrollbar">
          <DataTable
            className="display nowrap custom-scrollbar"
            data={filteredItems}
            columns={CandidatesTableColumn}
            striped
            pagination
            progressPending={CandidatesisLoading}
            highlightOnHover
            fixedHeader
            customStyles={customStyles}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default CandidateTable;
